<template>
  <div id="app">
    <!-- <headline v-if="isLoggedIn()" /> -->
    <div class="container">
      <div class="row">
        <div class="col-md-2 col-sm-3 col-xs-12">
          <sidebar :show-controls="isLoggedIn()" />
        </div>
        <div class="col-md-10 col-sm-9 col-xs-12 content">
          <router-view></router-view>
        </div>
      </div>
    </div>
    <!-- <footline v-if="isLoggedIn()" /> -->
    <animation :visible="hasAnimation" />
    <popup-msg
      :visible="showPopup"
      :type="popupType"
      :title="popupTitle"
      :text="popupText"
    />
  </div>
</template>

<script>
import './assets/css/style.less'
import './assets/css/font-awesome.css'
import sidebar from './components/Sidebar'
import animation from './components/Animation'
import headline from './components/Headline'
import footline from './components/Footline'
import popupMsg from './components/PopupMsg'
import auth from './auth'

export default {
  name: 'app',
  components: { sidebar, animation, headline, footline, popupMsg },
  data () {
    return {
      hasAnimation: false,

      showPopup: false,
      popupType: '',
      popupTitle: '',
      popupText: ''
    }
  },
  methods: {
    hideAnimation () {
      this.hasAnimation = false
    },
    showAnimation () {
      this.hasAnimation = true
    },
    showPopupMsg (text, type = 'info', title = '') {
      this.showPopup = true
      this.popupText = text
      this.popupType = type
      this.popupTitle = title

      setTimeout(function (f) { f() }, 1500, this.closePopupMsg)
    },
    closePopupMsg () {
      this.showPopup = false
    },
    isLoggedIn () {
      return auth.checkAuth()
    }
  }
}
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>



// WEBPACK FOOTER //
// App.vue?4fb12c16